'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';

import { GoArrowUpRight } from 'react-icons/go';
import { Reveal } from '../ui/reveal';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function ServiceCarouselCard({ service }: { service: any }) {
  const { t } = useTranslations();
  const imageUrl = service?.image?.url ?? '/images/placeholder.png';

  return (
    <Reveal variant="bottom">
      <div
        className={cn(
          'group relative flex h-[320px] w-full flex-col items-start justify-between overflow-hidden p-6 sm:h-[360px] sm:p-7 md:h-[400px] md:p-8 lg:h-[440px]',
        )}
      >
        <h3 className="relative z-20 text-xl font-bold tracking-tighter text-white sm:text-2xl md:text-3xl lg:text-[38px]">
          {service.name}
        </h3>
        <div
          className={cn('absolute inset-0 z-[1] h-full w-full', 'ea-service-slide__image-overlay')}
        />
        <Image
          src={imageUrl}
          alt={resolveImageAlt(service?.image, service?.name)}
          width={0}
          height={0}
          className="absolute inset-0 z-0 h-full w-full object-cover object-center"
          sizes="100vw"
        />
        <div
          className={cn(
            'absolute left-0 top-0 z-[10] h-full w-full translate-y-full bg-primary transition-all',
            'ease-in-out group-hover:translate-y-0',
          )}
        >
          <div className="relative flex h-full w-full items-end justify-end">
            <div className="relative z-[15] flex w-full items-end justify-between p-6 sm:p-7 md:p-8">
              <div className="flex w-full flex-col items-start justify-start gap-4 sm:gap-6 md:max-w-[242px] lg:gap-8">
                <HtmlRendererRaw
                  className={cn('w-full text-white', 'ea-service-slide__short-description')}
                  html={service.short_description}
                />
                <Button asChild variant={'primary-foreground'}>
                  <Link prefetch={false} href={service?.slug}>
                    {t('text792')} <GoArrowUpRight className="h-5 w-5 sm:h-6 sm:w-6" />
                  </Link>
                </Button>
              </div>
              <Image
                src={imageUrl}
                alt={resolveImageAlt(service?.image, service?.name)}
                width={0}
                height={0}
                className="relative z-[15] hidden h-[160px] w-full max-w-[250px] object-cover object-center md:block lg:h-[187px]"
                sizes="300px"
              />
            </div>
            <Image
              src={'/images/smaller-overlay.png'}
              alt={service.name}
              width={0}
              height={0}
              className={cn(
                'absolute left-0 top-0 z-[11] h-full w-full object-cover object-center opacity-10 mix-blend-screen',
                'ease-in-out group-hover:translate-y-0',
              )}
            />
          </div>
        </div>
      </div>
    </Reveal>
  );
}
